import React from 'react';
import { useNavigate } from 'react-router-dom';

function CardProducto({ producto }) {
  const navigate = useNavigate();

  const handleRedirect = (producto) => {
    navigate(`/detalle/${producto.codigo}`, { state: { producto } });
  };

  return (
    <button onClick={() => handleRedirect(producto)} className='h-72 w-52 m-3 bg-Blanco flex flex-col justify-between shadow-cardsuave rounded-lg'>
      {/* Contenedor de la imagen */}
      <div className='w-full h-28 rounded-t-lg relative'>
        
        <img src={producto.imagen} className='w-full h-full object-cover rounded-t-lg' alt='img-producto' />
        <div className={`absolute top-0 left-0 ${producto.disponible ? 'bg-Verde' : 'bg-Amarillo'} text-white px-2 py-1 rounded-br-lg rounded-tl-lg`}>
          {producto.disponible ? 'Disponible' : 'A Pedido'}
        </div>
      </div>
      
      {/* Descripción del producto */}
      <div className='flex-grow p-2 pt-3 ml-1'>
        <p className='text-base text-GrisOscuro line-clamp-3'>
          {producto.descripcion}
        </p>
      </div>

      {/* Precio del producto */}
      <div className='flex flex-col justify-end w-full text-center p-3'>
      <label className='font-bold'>
  {producto.mostrar_precio_dolar 
    ? `US$ ${Number(producto.precioventadolar).toLocaleString('es-AR')}`
    : `AR$ ${Number(producto.precioventapeso).toLocaleString('es-AR')}`}
</label>

      </div>
    </button>
  );
}

export default CardProducto;
